<template>
  <s-searchbar
    id="searchbar"
    use-dropdown
    :min-character="0"
    ref="navbar-search-input"
    placeholder="Cari program pelatihan"
    :fullwidth="fullwidth"
    cluster="k"
    v-model="search"
    class="searchbar"
    @click="searchProgram()"
    @keypress="handleEnter"
  >
    <template #dropdown>
      <search-recommendation v-if="isPrakerja" />
      <prakerja-recommendation
        v-else
        :keyword="search"
      ></prakerja-recommendation>
    </template>
  </s-searchbar>
</template>

<script>
import { mapState } from 'vuex'
import deviceDetector from 'mobile-device-detect'
import SearchRecommendation from '@/components/navbar/SearchRecommendation.vue'
import PrakerjaRecommendation from '@/components/navbar/PrakerjaRecommendation.vue'

export default {
  name: 'NavbarSearch',
  components: {
    PrakerjaRecommendation,
    SearchRecommendation
  },
  props: {
    fullwidth: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      search: '',
      isMobile: deviceDetector.isMobile
    }
  },
  computed: {
    ...mapState(['isPrakerja']),
    ...mapState('user', ['isLogin', 'userInfo'])
  },
  methods: {
    handleEnter (e) {
      if (e.keyCode === 13) {
        this.searchProgram()
      }
    },
    searchProgram () {
      const ref = this.isPrakerja ? 'prakerja-pencarian' : ''
      this.logEventAnalytics(
        this.isPrakerja ? 'prakerja_begin_search_icon_click' : 'kariermu_begin_search_icon_click',
        { search_keyword: this.search }
      )
      this.$router.push({
        path: '/program',
        query: {
          search: this.search,
          ...(ref) && { ref }
        }
      })
    },
    logEventAnalytics (eventName, additionalParams) {
      if (this.isLogin) {
        window.firebaseAnalytics.logEvent(eventName, {
          screen_url: window.location.href,
          user_profession: this.userInfo.profession_name,
          user_year_level: this.userInfo.year_level_name,
          user_is_admin: this.userInfo.is_admin,
          user_id: this.userInfo.id,
          source: this.isMobile ? 'mobile-web' : 'web',
          ...additionalParams
        })
      }
    }
  }
}
</script>

<style>
.custom-mobile-search {
  width: auto !important;
}

.custom-mobile-search .s-searchbar-input {
  height: 44px;
}

@media screen and (max-width: 1024px) {
  /* override searchbar dropdown only on mobile */
  .s-searchbar-dropdown {
    left: -56px;
    width: 100vw !important;
    height: 100vh;
  }
}

@media only screen and (min-width: 1024px) {
  .custom-mobile-search.is-fullwidth {
    width: -moz-available !important;
    width: -webkit-fill-available !important;
    width: stretch !important;
  }
}
</style>
